import {lazy} from "react";

export const VoyagePlanningLazy = lazy(() => import('./VoyagePlanning'))